module.exports = __webpack_public_path__ + "img/carousel-text.f1cb6e2e.png";